
import { defineComponent } from "vue";
import Modal from "@/components/generals/modal.vue";
import { TicketOptionFormInterface } from "@/store/Events/EventsInterfaces";
import uid from "lodash.uniqueid";
import TicketOptionForm from "@/components/events/admin/ticket-options/TicketOptionForm.vue";
import { Collapse } from "bootstrap";

export default defineComponent({
  name: "modify-ticket-option",
  props: ["option", "options", "event", "paymentOptions"],
  data() {
    return {
      editing: false,
      page: "information",
    };
  },
  components: {
    Modal,
    TicketOptionForm,
  },
  computed: {
    uniqueId() {
      return `ticket-option-${uid()}`;
    },
  },
  methods: {
    modifying(editing) {
      this.editing = editing;
    },
    resetData() {
      (this.$refs.ticketOptionForm as TicketOptionFormInterface).resetData();
    },
    saveData() {
      (this.$refs.ticketOptionForm as TicketOptionFormInterface).saveData();
    },
    async changePage(evt) {
      const {
        target: {
          dataset: { bsTarget },
        },
      } = evt;
      const target = bsTarget.replace("#", "");
      this.page = target.replace(`-${this.uniqueId}`, "");

      await Promise.allSettled(
        [...document.querySelectorAll(".collapse")].map((ele) =>
          Collapse.getOrCreateInstance(ele)[
            ele.id == target ? "show" : "hide"
          ]()
        )
      );
    },
  },
  mounted() {
    [...document.querySelectorAll(".collapse")].map((ele) =>
      Collapse.getOrCreateInstance(ele, {
        parent: `#collapse-parent-${this.uniqueId}`,
        toggle: false,
      })
    );
  },
});
